import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-about-page',
  standalone: true,
  imports: [RouterLink, NgFor],
  template: `
  <main class="page">
    <div class="container">
      <header class="head">
        <h1 class="h1">À propos</h1>
        <p class="lead">La data au service de la performance business.</p>
      </header>

      <section class="grid">
        <article class="card">
          <h2 class="h2">Notre mission</h2>
          <p>Structurer, analyser et valoriser les données pour en faire un levier de performance mesurable.</p>
        </article>
        <article class="card">
          <h2 class="h2">Notre vision</h2>
          <p>La donnée doit être un accélérateur stratégique et non un centre de coût.</p>
        </article>
        <article class="card span2">
          <h2 class="h2">Notre approche</h2>
          <ol class="steps">
            <li>Définition des KPI & enjeux business</li>
            <li>Architecture & Data Engineering (pipelines, qualité, modélisation)</li>
            <li>Visualisation & adoption</li>
            <li>Modèles prédictifs & automatisation</li>
            <li>Suivi & amélioration continue</li>
          </ol>
        </article>
      </section>

      <section class="trust card">
        <h2 class="h2">Ils nous font confiance</h2>
        <div class="pills">
          <span class="pill" *ngFor="let x of sectors">{{x}}</span>
        </div>
      </section>

      <div class="cta">
        <a class="btn primary" routerLink="/contact">Demander un audit</a>
        <a class="btn ghost" routerLink="/">Retour accueil</a>
      </div>
    </div>
  </main>
  `,
  styles: [`
    .page{ padding: 44px 0 70px; }
    .head{ max-width: 900px; }
    .lead{ color: var(--muted); font-weight: 750; }

    .grid{
      margin-top: 16px;
      display:grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 14px;
    }
    .card{
      border-radius: 26px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.03);
      padding: 18px;
      box-shadow: 0 30px 120px rgba(0,0,0,.45);
    }
    .card p{ margin: 10px 0 0; color: var(--muted); font-weight: 750; }
    .span2{ grid-column: 1 / -1; }
    .steps{ margin: 10px 0 0; padding-left: 18px; color: var(--muted); font-weight: 750; }
    .steps li{ margin: 8px 0; }

    .trust{ margin-top: 14px; }
    .pills{ margin-top: 10px; display:flex; gap: 10px; flex-wrap:wrap; }
    .pill{
      padding: 10px 12px;
      border-radius: 999px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      color: rgba(235,240,255,.82);
      font-weight: 900;
      font-size: 13px;
    }

    .cta{ margin-top: 16px; display:flex; gap: 12px; flex-wrap:wrap; }

    @media (max-width: 860px){
      .grid{ grid-template-columns: 1fr; }
    }
  `]
})
export class AboutPageComponent {
  sectors = ['SaaS', 'Retail', 'Finance', 'Industrie', 'E‑commerce'];
}
